import { RoutePath } from "src/types/path";

export const paths: RoutePath = {
  auth: {
    login: "/auth/login",
  },
  users: {
    root: "/users",
  },
  operations: {
    root: "/operations",
    detail: {
      suspendApp: "/operations/suspend-app",
      updateNotification: "/operations/update-notification",
      termsReconsent: "/operations/terms-reconsent",
      municipalityData: "/operations/municipality-data",
    },
  },
  pushNotifications: {
    root: "/push-notifications",
    detail: {
      send: "/push-notifications/send",
      edit: "/push-notifications/:id/edit",
    },
  },
  accountManagement: {
    root: "/account-management",
    create: "/account-management/create",
    detail: "/account-management/:id",
  },
  myAccount: {
    root: "/my-account",
    changePassword: {
      root: "/my-account/change-password",
      complete: "/my-account/change-password/complete",
    },
  },
  error: {
    404: "/404",
  },
} as const;
